<template>
  <b-container fluid id="abstract" class="section">
    <b-row>
      <b-col md="9" sm="12">
        <div class="title">
          <h2>About Us</h2>
        </div>
        <p v-html="this.abstract_data.text">
        </p>
      </b-col>
      <b-col md="3" sm="12" class="d-flex justify-content-end align-items-center">
        <wagtail-image class="img-fluid" :id="this.abstract_data.image"></wagtail-image>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import WagtailImage from "@/components/WagtailImage.vue";

export default {
  name: "Abstract",
  props: ["abstract_data"],
  components: {
    WagtailImage
  },
  data() {
    return {
      pages: null
    };
  }
};
</script>

<style lang="scss">
#abstract {
  border-bottom: 1px dashed $secondary-color !important;

  @include media-breakpoint-down(sm) {
    [class*="col-"]:not(:first-child) {
      padding-top: 1.5em;
      justify-content: start !important;
    }
  }
}
</style>